<template>
  <div
    class="rounded-2xl p-0 md:px-4 md:py-6 w-full"
    :class="{
      'bg-transparent md:bg-white-005': !daoPageInfo.isCustom.value,
      [daoPageInfo.vueState.customClass === 'ape'
        ? 'bg-transparent md:bg-ape-main'
        : 'bg-transparent md:bg-aavegotchi-main']: daoPageInfo.isCustom.value,
    }"
    style="height: fit-content"
    v-if="state.ftAddress || state.nftName"
  >
    <div class="text-base md:text-xl font-bold mb-2">Governance Token</div>
    <div v-if="state.ftAddress">
      <div
        v-if="state.ftBaseInfo.length === 1"
        class="flex items-center justify-between w-36 h-8 py-1.5 rounded-lg"
      >
        <a
          :href="state.selectedFtBase.link"
          target="_blank"
          class="flex items-center"
        >
          <UiImg
            class="w-5 h-5 mr-2"
            :src="
              state.selectedFtBase.logo ||
              require('@/assets/icons/nftnologo.avif')
            "
          ></UiImg>
          <div class="flex items-center line-clamp-1">
            <span class="text-whitebase mr-1">
              {{ state.selectedFtBase.name }}
            </span>
          </div>
        </a>
      </div>
      <el-dropdown
        trigger="click"
        placement="bottom"
        @command="handleClick"
        v-if="state.ftBaseInfo.length > 1"
      >
        <div
          class="
            flex
            items-center
            justify-between
            w-36
            h-8
            px-2
            py-1.5
            rounded-lg
            border border-white-010
          "
        >
          <div class="flex items-center">
            <UiImg
              class="w-5 h-5 mr-2"
              :src="
                state.selectedFtBase.logo ||
                require('@/assets/icons/nftnologo.avif')
              "
            ></UiImg>
            <div class="flex items-center line-clamp-1">
              <span class="text-whitebase mr-1">
                {{ state.selectedFtBase.name }}
              </span>
              <span class="text-white-040">
                ({{ NetworkSymbol[state.selectedFtBase.chain] }})
              </span>
              <!-- // state.selectedFtBase.chain === 'matic'
                  //   ? 'Polygon'
                  //   : state.selectedFtBase.chain?.charAt(0).toUpperCase() +
                  //     state.selectedFtBase.chain?.slice(1) -->
            </div>
          </div>
          <span
            class="el-dropdown-link text-whitebase iconfont w-4 h-4"
            :class="{ 'icon-right': !state.isOpen, 'icon-xia1': state.isOpen }"
          >
          </span>
        </div>

        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="(ft, i) in state.ftBaseInfo"
              :key="i"
              :command="ft"
              class="h-8 px-2 py-1.5"
              :class="{ el_tab_active: ft === state.selectedFtBase }"
              style="min-width: 144px"
              ><div class="flex items-center line-clamp-1">
                <span class="text-whitebase mr-1">{{ ft.name }}</span>
                <span class="text-white-040">
                  ({{ NetworkSymbol[ft.chain] }})
                </span>
              </div></el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <a :href="state.selectedFtBase.link" target="_blank">
        <div class="mt-2 flex items-center group">
          <!-- <UiImg
            class="w-6 h-6 mr-2"
            :src="state.ftLogo || require('@/assets/icons/nftnologo.avif')"
          ></UiImg> -->
          <div class="text-xs">
            <!-- <div class="font-bold group-hover:underline">
              {{ state.ftName }}
            </div> -->
            <div>
              ${{ formatVal(state.price, { bit: 2, omit: true }) }}
              <span :style="`color:${getRateColor(state.rate)}`"
                >({{ suffixNum((state.rate * 100).toFixed(2)) }}%)</span
              >
            </div>
          </div>
        </div>
      </a>

      <FtLine
        :data="state.ftList"
        :loading="loading"
        :text="state.ftDesc"
        :isCustom="daoPageInfo.isCustom.value"
      ></FtLine>
      <!-- <div v-else class="mt-2 text-white-070">
        mVOX: This is the MeebitsDAO governance token. General Members can claim
        one mVOX per month and delegate their mVOX to a Founder to increase
        their voting power as the General Member's representative. mVOX tokens
        are ERC-20 on Polygon. https://www.meebitsdao.world/claim
      </div> -->
    </div>

    <div>
      <div
        v-if="state.ftAddress && state.nftName"
        class="w-full my-6"
        style="height: 1px; background: #ffffff1a"
      ></div>
      <div v-if="state.nftName" :class="{ 'mt-6': !state.ftAddress }">
        <div
          v-if="state.nftBaseInfo.length === 1"
          class="flex items-center justify-between w-36 h-8 py-1.5 rounded-lg"
        >
          <div class="flex items-center">
            <a class="flex items-center" :href="state.nftLink" target="_blank">
              <UiImg
                class="w-5 h-5 mr-2"
                :src="
                  state.selectedNftBase.logo ||
                  require('@/assets/icons/nftnologo.avif')
                "
              ></UiImg>
              <span class="flex items-center line-clamp-1">
                <span class="text-whitebase mr-1">
                  {{ state.selectedNftBase.name }}
                </span>
              </span></a
            >
          </div>
        </div>
        <el-dropdown
          trigger="click"
          placement="bottom"
          @command="handleNFTClick"
          v-if="state.nftBaseInfo.length > 1"
        >
          <div
            class="
              flex
              items-center
              justify-between
              w-36
              h-8
              px-2
              py-1.5
              rounded-lg
              border border-white-010
            "
          >
            <div class="flex items-center">
              <a
                class="flex items-center"
                :href="state.nftLink"
                target="_blank"
              >
                <UiImg
                  class="w-5 h-5 mr-2"
                  :src="
                    state.selectedNftBase.logo ||
                    require('@/assets/icons/nftnologo.avif')
                  "
                ></UiImg>
                <span class="flex w-full items-center line-clamp-1">
                  <span class="text-whitebase mr-1">
                    {{ state.selectedNftBase.name }}
                  </span>
                </span></a
              >
            </div>
            <span
              class="el-dropdown-link text-whitebase iconfont w-4 h-4"
              :class="{
                'icon-right': !state.isOpen,
                'icon-xia1': state.isOpen,
              }"
            >
            </span>
          </div>

          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(nft, i) in state.nftBaseInfo"
                :key="i"
                :command="nft"
                class="h-8 px-2 py-1.5"
                :class="{ el_tab_active: nft === state.selectedNftBase }"
                style="min-width: 144px"
                ><div class="flex items-center line-clamp-1">
                  <span class="text-whitebase mr-1">{{ nft.name }}</span>
                </div></el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <!-- <a :href="state.nftLink" target="_blank">
          <div class="flex group">
            <UiImg class="w-8 h-8 rounded mr-2" :src="state.nftLogo"></UiImg>
            <div class="font-bold group-hover:underline">
              {{ state.nftName }}
            </div>
          </div>
        </a> -->

        <NftScatter
          :data="state.list"
          :loading="loading"
          :formatter="onScatterFormatter"
          :text="state.nftDesc"
        ></NftScatter>
        <!-- <div v-else class="mt-2 text-white-070">
          MDAO Founders: MeebitsDAO Founders token are given to members that
          contributed 1 ETH to the DAO Treasury. It gives the Founders voting
          rights and ability to create proposals. Founders tokens are NFTs
          (ERC-721) on the Polygon network. Maximum Supply: 200 Current Supply:
          184
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { queryOvVoteData } from '@/api/dao';
import { useReqByBool } from '@/hooks';
import { inject, onMounted, reactive } from 'vue';
import UiImg from '@/components/UiImg.vue';
import { formatVal, getRateColor, suffixNum, formatDate } from '@/utils';
import NftScatter from './NftScatter.vue';
import axios from 'axios';
import FtLine from './FtLine.vue';
import { NetworkSymbol } from '@/constants';

const daoPageInfo = inject('daoPageInfo');

const state = reactive({
  list: [],
  ftList: [],
  price: 0,
  rate: 0,
  nftLogo: '',
  nftName: '',
  ftLogo: '',
  ftName: '',
  ftAddress: '',
  selectedFtBase: [],
  selectedNftBase: [],
});

const getGraphData = async () => {
  state.ftLogo = state.selectedFtBase.logo;
  state.ftName = state.selectedFtBase.name;
  state.ftAddress = state.selectedFtBase.contractAdd;
  state.ftDesc = state.selectedFtBase.desc;
  try {
    const ress = await axios.get(
      `https://api.coingecko.com/api/v3/coins/${state.selectedFtBase.coinId}/market_chart/?vs_currency=usd&days=7`,
    );

    if (ress.data) state.ftList = ress.data.prices;
    else {
      state.ftList = [];
      state.price = 0;
      state.rate = 0;
      return;
    }
    state.price = state.ftList[state.ftList.length - 1][1];
    const a = state.ftList[state.ftList.length - 1][1];
    const b = state.ftList[state.ftList.length - 24][1];
    state.rate = (a - b) / b;
  } catch (error) {
    console.log(error);
    state.ftList = [];
    state.price = [];
    state.rate = 0;
    return;
  }
};
const handleClick = (newFtBase) => {
  state.selectedFtBase = newFtBase;
  getGraphData();
};
const handleNFTClick = (newNftBase) => {
  state.selectedNftBase = newNftBase || {};
  let nftTrade = state.selectedNftBase.nftTrade || [];

  state.nftLogo = state.selectedNftBase.logo;
  state.nftName = state.selectedNftBase.name;
  state.nftLink = state.selectedNftBase.link;

  nftTrade.forEach((x) => (x.historyPrice = x.price));
  state.list = nftTrade;
  getGraphData();
};

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryOvVoteData(daoPageInfo.vueState.info.id);
  let { nftBaseInfo, ftBaseInfo, nftTrade } = res;

  state.ftBaseInfo = ftBaseInfo || [];
  state.selectedFtBase = ftBaseInfo[0] || {};
  state.nftBaseInfo = nftBaseInfo || [];
  state.selectedNftBase = state.nftBaseInfo[0] || {};
  nftTrade = state.selectedNftBase.nftTrade || [];

  state.nftLogo = state.selectedNftBase.logo;
  state.nftName = state.selectedNftBase.name;
  state.nftLink = state.selectedNftBase.link;

  nftTrade.forEach((x) => (x.historyPrice = x.price));
  state.list = nftTrade;

  state.nftDesc = state.selectedNftBase.desc;
  console.log(state);
  getGraphData();
});

const onScatterFormatter = ({ dataIndex, componentType }) => {
  if (componentType == 'markLine') {
    return '';
  }

  const info = state.list[dataIndex];

  return `${state.nftName}#${info.tokenId}<br/>
  <i class="iconfont icon-ETH2-24 text-xs"></i>${info.price} <br/> ${formatDate(
    info.tradeTime,
    'MMM DD YYYY  hh:mmA',
  )} `;
};

onMounted(() => {
  loadData();
});
</script>

<style>
.el_tab_active {
  background-color: rgba(255, 255, 255, 0.07);
}
.el-popper__arrow {
  display: none !important;
}
.el-dropdown-menu__item {
  color: white !important;
}
.el-dropdown-menu {
  padding: 0 !important;

  background: #2a2e33ff !important;
}
.el-dropdown-menu__item:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}
.el-popper.is-light {
  border: none !important;
  background: #2a2e33ff !important;
}
</style>
